import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import DataTable from "react-data-table-component";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch,faEdit, faAddressBook} from "@fortawesome/free-solid-svg-icons";
import "assets/css/grid.css";
import { useListarUsuariosSistema } from '../../hooks/useListarUsuariosSistema';
import { cargosSistema} from '../../data/UsuarioSistema'

const columnas=[
    {
        name:'ID',
        selector: row => row.Usuario,
        sorteable:true,
        omit:true
    },
    {
        name:'Nombre',
        selector: row => row.NombreSocial,
        sorteable:true,
        grow:3
    },
    {
        name:'Cargo',
        selector:row => cargosSistema?.find(p=>p.Id==row.CargoId)?.Nombre,
        sorteable:true
    },
    {
        name:'Correo',
        selector:row => row.Correo,
        sorteable:true,
        right:true
    },
    {
        name:'Acciones',
		cell: row => (
            <>
            <a href={'EditarUsuarioSistema/'+row.Usuario} rel="noopener noreferrer">
            	<FontAwesomeIcon icon={faEdit} />
            </a>
            &nbsp;&nbsp;&nbsp;
            <a href={'AgendaCompartida/'+row.Usuario} rel="noopener noreferrer">
            	<FontAwesomeIcon icon={faAddressBook} />
            </a>
            </>       
        )
    }

];
const paginacionOpciones={
    rowsPerPageText:'Número elementos',
    rangeSeparatorText:'de',
    selectAllRowsItemsText:'Todos'
}


 function UsuarioSistemaGrid(){
    const { usuariosSistema,getUsuariosSistema } = useListarUsuariosSistema();
    
    const onChange=async e=>{
        e.persist();
        getUsuariosSistema(e.target.value);
    }

        return (
            <div className='table-responsive'>
                <div className='barraBusqueda'>
                    <input
                        type="text"
                        placeholder="Buscar"
                        className="textField"
                        name="busqueda"
                        onChange={onChange}
                        
                    />
                    <button type='button' className='btnBuscar'>
                        <FontAwesomeIcon icon={faSearch} />
                    </button>
                </div>

            <DataTable
                columns={columnas}
                data={usuariosSistema}
                pagination
                paginationComponentOptions={paginacionOpciones}
                fixedHeader
                fixedHeaderScrollHeight='600px'
                noDataComponent="No hay elementos para mostrar"
                striped={true}
                
            />
            </div>

        )

    
}
export default UsuarioSistemaGrid;

